import { X } from 'lucide-react'
import { useState } from 'react'

/**
 * The agreement to share contact details, asked at the moment it matters: pressing Connect (the
 * sender) or Accept (the receiver). The wording is the network's own, passed in, so what a person
 * sees is what was recorded against their agreement.
 */
export function ContactConsentDialog({
  title,
  statement,
  confirmLabel,
  onConfirm,
  onCancel,
}: {
  title: string
  statement: string
  confirmLabel: string
  onConfirm: () => void
  onCancel: () => void
}) {
  const [agreed, setAgreed] = useState(false)

  return (
    <div
      // Above the map's detail dialogs (z-[1100]), which are still open behind it: at the same level
      // this one, earlier in the page, was painted over and Connect looked like it did nothing.
      className="fixed inset-0 z-[1200] grid place-items-center overflow-y-auto bg-ink-900/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="card-pad max-h-[90vh] w-full max-w-sm overflow-y-auto bg-white">
        <div className="flex items-start justify-between gap-3">
          <h2 className="font-bold text-ink-900">{title}</h2>
          <button onClick={onCancel} aria-label="Close" className="text-ink-400 hover:text-ink-700">
            <X size={18} />
          </button>
        </div>

        <label className="mt-4 flex items-start gap-2 text-sm text-ink-700">
          <input
            type="checkbox"
            className="mt-1"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span>{statement}</span>
        </label>

        <div className="mt-5 flex justify-end gap-2">
          <button onClick={onCancel} className="btn-ghost !px-3 !py-1.5 text-sm">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!agreed}
            className="btn-sun !px-3 !py-1.5 text-sm disabled:cursor-not-allowed disabled:opacity-50"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
